import { createSliceSelectors } from '../utils'

const AvatarSelectors = createSliceSelectors('avatar', ['isAvatarMuted'])

export default AvatarSelectors
